import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterTeam'
})
export class FilterTeamPipe implements PipeTransform {



  transform(events: any[], team: string[] | null | undefined): any[] {
    if (!events || team == null || team == null || team.length == 0) {
      return events;
    } else {     
      let eventsFilter: any = []
      events.forEach(function(event: any) {  
        if (event?.tagsFilter?.length) {
          event.tagsFilter.forEach(function(ele: string) {
            if (team!.indexOf(ele.toLocaleLowerCase()) > -1) {                 
                eventsFilter[eventsFilter.length] = event
              }                         
            });   
          }
                  
        });         
    
      return eventsFilter
    } 
  }
}
